import Translations from '@helpers/translations'
import { ReturnsProduct } from '@api/returns/types'
import {
  isAllowedProductCategoryBySku,
  returnsClickEvent
} from '@components/returns/helpers'
import { Button } from '@components/ui/Button'
import { Values, ReasonListItem } from '@components/returns/types'
import ExchangeNotification from '../../shared/ExchangeNotification'
import { PartialState, ValuesState } from '../../index'
import FormWrapper from '../../shared/FormWrapper'
import {
  Option,
  SelectField
} from '@components/ui/formElements/form/selectFields/SelectField'
import styles from '../../shared/styles.module.scss'
import { checkStoreIs } from '@helpers/env'

type ReasonStepProps = {
  selectedProduct: ReturnsProduct
  values: Values
  reasonList: ReasonListItem[]
  onExchange: (args: {
    step: number
    savedFitsizes?: PartialState<ValuesState['sizes']>
  }) => void
  onUpdate: () => void
  isLastStep: boolean
}

export function ReasonStep({
  selectedProduct,
  values,
  reasonList,
  onUpdate,
  onExchange,
  isLastStep
}: ReasonStepProps) {
  const selectedReason = values.reason
  const buttonText = isLastStep
    ? Translations.localise('pages.returns.done')
    : 'Next'

  const { isMTO } = selectedProduct
  const isUS = checkStoreIs('us')

  const handleUpdate = () => {
    returnsClickEvent({
      label: buttonText
    })
    onUpdate()
  }

  const handleOnExchange = ({
    sizes,
    step
  }: {
    sizes?: PartialState<ValuesState['sizes']>
    step: number
  }) => {
    if (sizes) {
      onExchange({ step: 1, savedFitsizes: sizes })
    } else {
      onExchange({ step })
    }
  }

  const matchesAllowedProductCategory = selectedProduct?.sku
    ? isAllowedProductCategoryBySku(selectedProduct.sku)
    : true

  return (
    <>
      <FormWrapper title="Reason for refund">
        <SelectField
          id="reason"
          options={reasonList as unknown as Option[]}
          name="reason"
          required={true}
          placeholder="Please select"
        />
        {!isUS && !isMTO && matchesAllowedProductCategory && (
          <ExchangeNotification
            type="refund"
            reason={selectedReason}
            productSizes={selectedProduct?.sizes}
            productType={selectedProduct.product_type}
            onExchange={handleOnExchange}
          />
        )}
      </FormWrapper>
      <Button
        disabled={!selectedReason}
        classes={styles.returnsForm__button}
        variant="primary"
        fullWidth="always"
        onClick={handleUpdate}
      >
        {buttonText}
      </Button>
    </>
  )
}
